import { useEffect } from 'react';
import { pushCSITrigger } from 'utils/feedbackScript';
import { useProfileStorage } from './profile';

export const useCSI = () => {
  const { profile } = useProfileStorage();
  const username = profile?.username;

  // Initialization & injection to DOM & run
  useEffect(() => {
    const timeout = setTimeout(() => pushCSITrigger(username));

    return () => clearTimeout(timeout);
  }, [username]);
};
